import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/pro-light-svg-icons'

import {
  DashboardModuleListItem, IconWithMenu, Image, Link,
} from '@domain-group/suit-theme'

import useAgency from '@hooks/useAgency'
import { generateUrls } from '@hooks/useCampaign'

import type { CampaignModel } from '@models/types'

import ImpersonateEntityButton from '@components/ImpersonateEntityButton'

import placeholderImageUrl from './assets/campaign_image_400x400.png'

const CampaignListItem = (props: { campaign: CampaignModel, displayMode?: string }) => {
  const { campaign, displayMode } = props
  const { agency_id, default_image, title: campaignTitle } = campaign

  const {
    agency,
    agency: { title: agencyTitle },
    callbacks: { loginAsAgency },
  } = useAgency({ id: agency_id })

  const { campaignEditDashboardUrl } = generateUrls(campaign)

  const showImage = !!(displayMode === 'large-list')

  return (
    <DashboardModuleListItem
      // @ts-expect-error TS2322
      imageComponent={showImage && (
        <Image
          backgroundSize="cover"
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
          placeholderUrl={placeholderImageUrl}
          url={default_image}
        />
      )}
      isSidebar
      secondaryText={agencyTitle}
      title={campaignTitle}
    >
      <IconWithMenu
        boxProps={{ position: 'relative' }}
        icon={(
          <Link greyLink>
            <FontAwesomeIcon icon={faCog} />
          </Link>
      )}
        shouldUsePortal
      >
        {/*
         // @ts-expect-error TS2741 */}
        <IconWithMenu.Menu closeOnClick>
          <ImpersonateEntityButton
            as="a"
            border="none"
            // @ts-expect-error TS2322
            callbacks={{ loginAsEntity: loginAsAgency }}
            // @ts-expect-error TS2322
            entity={agency}
            redirectPath={campaignEditDashboardUrl}
            requestOptions={{
              redirect: campaign.paths?.edit,
            }}
            style={{
              fontSize: '12px', width: '100%', justifyContent: 'left',
            }}
          />
        </IconWithMenu.Menu>
      </IconWithMenu>
    </DashboardModuleListItem>
  )
}

export default CampaignListItem
